import React, { Component } from "react";
// TODO(mikexstudios): Think about removing this dependency for directly adding
// codemirror. See: https://github.com/JedWatson/react-codemirror/issues/106
import ReactCodeMirror from "react-codemirror";
import "codemirror/mode/markdown/markdown";
import "codemirror/addon/display/placeholder";
import "codemirror/lib/codemirror.css";
import "codemirror/theme/monokai.css";
import throttle from "throttleit";

import "./PageEdit.css";

class PageEdit extends Component {
  constructor(props) {
    super(props);
    this.codeMirrorEl = null;

    this.state = {
      // Store a copy of content locally so that we can update this state more
      // frequently (making the editor more responsive) than the parent state.
      content: this.props.content
    };

    this.codeMirrorOptions = {
      mode: "markdown",
      theme: "monokai",
      tabSize: 2,
      autofocus: true,
      lineNumbers: true,
      lineWrapping: true,
      placeholder:
        "# Page Title\n\nJust start typing here to create this page!",
      extraKeys: {
        Esc: () => {
          // Since CM intercepts all key presses, the global key listener will
          // not fire. This, we use CM's built in key handling to toggle edit
          // mode.
          this.props.toggleEditMode();
        }
      }
    };
  }

  componentWillReceiveProps(nextProps) {
    this.setState({ content: nextProps.content });
  }

  componentDidUpdate(prevProps, prevState) {
    // Update CM editor if we swapped to it from show to edit. This fixes a bug
    // where the gutter (line no) doesn't render properly:
    // https://github.com/JedWatson/react-codemirror/issues/6. Using the
    // autofocus addon doesn't work. Probably a react-codemirror problem.
    if (!prevProps.isEditMode && this.props.isEditMode) {
      this.codeMirrorEl.codeMirror.refresh();
      this.codeMirrorEl.codeMirror.focus(); //  restores cursor position
    }
  }

  render() {
    let containerClass = "type-page-edit-container";
    if (this.props.isEditMode) {
      containerClass += " type-page-edit-editmode";
    }

    return (
      <div className={containerClass}>
        <ReactCodeMirror
          ref={el => (this.codeMirrorEl = el)}
          options={this.codeMirrorOptions}
          value={this.state.content}
          onChange={this.handleEditorChange_}
        />
      </div>
    );
  }

  handleEditorChange_ = content => {
    this.setState({ content: content });
    this.updateParentContent_();
  };

  updateParentContent_ = throttle(() => {
    this.props.setContent(this.state.content);
  }, PageEdit.UPDATE_CONTENT_THROTTLE);
}

PageEdit.UPDATE_CONTENT_THROTTLE = 500; // ms

export default PageEdit;



// WEBPACK FOOTER //
// ./src/components/PageEdit.js